import { render, staticRenderFns } from "./page-header-industry.vue?vue&type=template&id=98f4784c&scoped=true"
import script from "./page-header-industry.vue?vue&type=script&lang=js"
export * from "./page-header-industry.vue?vue&type=script&lang=js"
import style0 from "./page-header-industry.vue?vue&type=style&index=0&id=98f4784c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f4784c",
  null
  
)

export default component.exports